import { useCashWinningsMode } from '../../hooks/useCashWinningsMode';
import { useStores } from '../../stores/useStores';

// Indiana (cash-winnings) users see a cash balance alongside the SC ticket balance,
// but only while the SC lobby is active. Everywhere else the header is single-balance.
export function useShowDualBalance(): boolean {
  const { coinTypeStore } = useStores();
  const cashWinningsMode = useCashWinningsMode();
  return cashWinningsMode && coinTypeStore.coinType === 'SC';
}
